
/* @ngInject */
export default function hpPopover($window) {
    return {
        restrict: 'A',
        link(scope, element) {
            element.bind('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                if (element.hasClass('selected')) {
                    element.removeClass('selected');
                    element.triggerHandler('hide');
                } else {
                    element.addClass('selected');
                    element.triggerHandler('show');
                }

                const popups = $window.document.querySelectorAll('*[hp-popover]');
                for (let i = 0; i < popups.length; i++) {
                    const popup = popups[i];
                    const popupElement = angular.element(popup);

                    if (popup !== element[0]) {
                        if (popupElement.hasClass('selected')) {
                            popupElement.triggerHandler('hide');
                            popupElement.removeClass('selected');
                        }
                    }
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpPopover.directive.js